import { createContext, useCallback, useContext, useEffect } from 'react';
import Breadcrumb from '@Services/Breadcrumb';
import { trackShowHideConditions } from '@Pages/Results/analytics';

export const ToggleConditionsGlobalContext = createContext([]);

export function useToggleConditionsGlobal({ databaseId, resultName }) {
  const [showConditions, setShowConditions] = useContext(ToggleConditionsGlobalContext);

  useEffect(() => {
    const conditionsState = Breadcrumb.getResultsStateForDb(databaseId, 'reactionConditions');
    // restore state of conditions toggle
    if (conditionsState) {
      setShowConditions(conditionsState.show);
    } else {
      // new hit set or there is no saved info, so initialize
      Breadcrumb.updateResultsStateForDb(databaseId, 'reactionConditions', {
        show: showConditions,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [databaseId]);

  const toggleConditions = useCallback(() => {
    const toggled = !showConditions;

    trackShowHideConditions(toggled);
    setShowConditions(toggled);
    Breadcrumb.updateResultsStateForDb(databaseId, 'reactionConditions', {
      resultName,
      show: toggled,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showConditions]);

  return [showConditions, toggleConditions];
}
